/* eslint-disable no-console */
import { KENTICO_TYPES } from 'common/consts/kentico';
import Client from './kenticoClient';

class ForInvestorsService {
  client = Client;
  async fetchInvestorsData() {
    try {
      const forInvestorsDataItems = await this.client.items()
        .type(KENTICO_TYPES.FOR_INVESTORS)
        .depthParameter(5)
        .getPromise();

      if (forInvestorsDataItems.isEmpty) {
        return null;
      }
      return forInvestorsDataItems.lastItem;
    } catch (err) {
      console.log('Failed to fetch core data', err);
      return null;
    }
  }
}

export default new ForInvestorsService();



// WEBPACK FOOTER //
// ./src/services/ForInvestors.service.js